var _path, _path2, _path3, _g, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8884 12.8957H15.8404C13.9434 12.8957 12.3994 11.3527 12.3984 9.45667C12.3984 7.55867 13.9424 6.01467 15.8404 6.01367H19.8884C20.3024 6.01367 20.6384 6.34967 20.6384 6.76367C20.6384 7.17767 20.3024 7.51367 19.8884 7.51367H15.8404C14.7694 7.51467 13.8984 8.38567 13.8984 9.45567C13.8984 10.5247 14.7704 11.3957 15.8404 11.3957H19.8884C20.3024 11.3957 20.6384 11.7317 20.6384 12.1457C20.6384 12.5597 20.3024 12.8957 19.8884 12.8957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2964 10.1436H15.9844C15.5704 10.1436 15.2344 9.80755 15.2344 9.39355C15.2344 8.97955 15.5704 8.64355 15.9844 8.64355H16.2964C16.7104 8.64355 17.0464 8.97955 17.0464 9.39355C17.0464 9.80755 16.7104 10.1436 16.2964 10.1436Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1187_29610",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20.6386V19.1729H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1187_29610)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.998 1.5C3.518 1.5 1.5 3.518 1.5 5.998V13.175C1.5 15.655 3.518 17.673 5.998 17.673H14.642C17.122 17.673 19.139 15.655 19.139 13.175V5.998C19.139 3.518 17.122 1.5 14.642 1.5H5.998ZM14.642 19.173H5.998C2.691 19.173 0 16.482 0 13.175V5.998C0 2.69 2.691 0 5.998 0H14.642C17.949 0 20.639 2.69 20.639 5.998V13.175C20.639 16.482 17.949 19.173 14.642 19.173Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6842 6.03809H5.28516C4.87116 6.03809 4.53516 5.70209 4.53516 5.28809C4.53516 4.87409 4.87116 4.53809 5.28516 4.53809H10.6842C11.0982 4.53809 11.4342 4.87409 11.4342 5.28809C11.4342 5.70209 11.0982 6.03809 10.6842 6.03809Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.bd52857a3dd4d400538c1fa9d268ce5e.svg";
export { ForwardRef as ReactComponent };